import { render } from "./AddVideos.vue?vue&type=template&id=5a1a1e12"
import script from "./AddVideos.vue?vue&type=script&lang=js"
export * from "./AddVideos.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\murodjon\\Desktop\\admin-uzcsd-uz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__